import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 48, color = 'var(--primary-color)' }) => {
  return (
    <div className="global-spinner-overlay">
      <div
        className="global-spinner"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default LoadingSpinner;
